import { inject, Injectable } from '@angular/core';
import { DatabaseModelApiService } from '../database-model-api/database-model-api.service';
import { DatabaseModelService } from '../database-model/database-model.service';
import { BehaviorSubject, map, Observable, switchMap, take, tap } from 'rxjs';
import { SavedDatabaseModel } from '../../models/saved/saved-database-model.type';
import { DatabaseModel } from '../../models/class/database-model.class';
import { DatabaseModelBuilder } from '../../models/builder/database-model-builder.class';
import { FIRST_OF_OBSERVABLE, ID_FOR_NEW_DATABASE_MODEL, ID_FOR_UNSAVED_DATABASE_MODEL } from '../../models/constant/constants.constant';
import { LocalStorageService } from '../../../../core/services/local-storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class DatabaseModelFacadeService {
  private _dbmApiService: DatabaseModelApiService = inject(DatabaseModelApiService);
  private _dbmService: DatabaseModelService = inject(DatabaseModelService);
  private _localStorageService: LocalStorageService = inject(LocalStorageService);

  save$(): Observable<boolean> {
    return this._dbmService.getModel$().pipe(
      take(FIRST_OF_OBSERVABLE),
      switchMap((model: DatabaseModel) => this.createOrSave$(model)),
      map((savedModel: SavedDatabaseModel | null) => {
        if (savedModel) {
          this._dbmService.setModel(DatabaseModelBuilder.buildFromSavedDto(savedModel));
          return true;
        }
        return false;
      })
    );
  }

  createOrSave$(model: DatabaseModel): Observable<SavedDatabaseModel | null> {
    const toCreate: boolean = model.getId() === undefined || (model.getId() as number) <= ID_FOR_NEW_DATABASE_MODEL ? true : false;
    if (toCreate) return this._dbmApiService.postDatabaseModel$(DatabaseModelBuilder.buildToCreate(model));
    return this._dbmApiService.updateDatabaseModel$(DatabaseModelBuilder.buildToSaved(model));
  }

  updateTitle(newTitle: string): void {
    this._dbmService.updateTitle(newTitle);
  }

  getSavedDatabaseModel(paramId: number): Observable<SavedDatabaseModel> {
    if (paramId === ID_FOR_NEW_DATABASE_MODEL) {
      const newDatabaseModel: SavedDatabaseModel = {
        id: ID_FOR_NEW_DATABASE_MODEL,
        title: 'Modèle sans nom',
        tableList: [],
        linkList: [],
        userId: ID_FOR_UNSAVED_DATABASE_MODEL,
      };
      this._dbmService.setModel(DatabaseModelBuilder.buildFromSavedDto(newDatabaseModel));
      return new BehaviorSubject(newDatabaseModel).asObservable();
    }
    if (paramId === ID_FOR_UNSAVED_DATABASE_MODEL) {
      return this._dbmService.getActualModel$();
    }
    return this._dbmApiService.getDatabaseModelById$(paramId).pipe(
      tap((savedModel: SavedDatabaseModel) => this._localStorageService.saveModel(DatabaseModelBuilder.buildFromSavedDto(savedModel)))
    );
  }
}
